"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageComponentImport = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsUploadFile = require("../../components/DmsUploadFile/DmsUploadFile");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageComponentImport Component
 * 
 * @description Component for importing component files. Displays a DmsPage layout with a DmsUploadFile component for managing component file import operations.
 * 
 * @component
 * @example
 * return (
 *   <DmsPageComponentImport />
 * )
 * 
 * @returns {JSX.Element} The Import Component File page.
 */
const DmsPageComponentImport = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "Import Component File"
  }, /*#__PURE__*/_react.default.createElement(_DmsUploadFile.DmsUploadFile, {
    table_url: "/component/files/table",
    upload_url: "/component/file_upload",
    import_url: "/component/file_import",
    download_url: "/file/download"
  }));
};
exports.DmsPageComponentImport = DmsPageComponentImport;